// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".offers-display[data-v-248525b2]{display:flex}.offers-display__icon[data-v-248525b2]{width:32px;height:32px;margin-inline-end:8px;cursor:pointer;border:1px solid transparent}.offers-display__icon--more[data-v-248525b2]{border:1px solid #6f7d90;border-radius:20%;font-size:12px;display:flex;justify-content:center;align-items:center;width:32px;height:32px}.offers-display__icon--more[data-v-248525b2]:hover{background-color:#1c252f}", ""]);
// Exports
module.exports = exports;
